import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ClubsStore } from 'src/app/clubs/clubs.store';
import { PublicationHelper } from 'src/app/helpers/publication.helper';
import { Publication } from 'src/app/models/clubs/publication.model';
import { LinkifyPipe } from 'src/app/pipes/linkify.pipe';
import { MentionMembersPipe } from 'src/app/pipes/mention-members.pipe';
import { MemberApiService } from 'src/app/services/clubs/member.api.service';
import { PublicationService } from 'src/app/services/clubs/publication.service';
import { ReactionTypeService } from 'src/app/services/clubs/reaction-type.service';
import { DocumentsService } from 'src/app/services/dms/documents.service';
import { AccountsService } from 'src/app/services/identity/accounts.service';
import { PostsSignalrService } from 'src/app/services/signalr/posts-signalr.service';
import { AddNewCommentComponent } from 'src/app/shared/components/publication/add-new-comment/add-new-comment.component';
import { BasePostCardComponent } from 'src/app/shared/components/publication/base-post-card/base-post-card.component';


@Component({
    selector: 'app-drawer-notification-post',
    templateUrl: './drawer-notification-post.component.html',
    styleUrls: ['drawer-notification-post.component.scss'],
    providers: [MentionMembersPipe, LinkifyPipe],
})
export class DrawerNotificationPostComponent extends BasePostCardComponent {
    @ViewChild('addNewCommentComponent')
    public addNewCommentComponent: AddNewCommentComponent;
    @Output() seeMoreSignal = new EventEmitter<[Publication, boolean]>();

    @Input() public publicationClubAndRoomName: [string, string];

    constructor(
        protected override readonly accountService: AccountsService,
        override readonly clubsStore: ClubsStore,
        protected override readonly documentService: DocumentsService,
        protected override linkifyPipe: LinkifyPipe,
        protected override readonly memberService: MemberApiService,
        protected override mentionPipe: MentionMembersPipe,
        protected override readonly postsSignalrService: PostsSignalrService,
        public override readonly publicationHelper: PublicationHelper,
        protected override publicationService: PublicationService,
        protected override reactionTypeService: ReactionTypeService,
        private readonly router: Router,
        public override sanitizer: DomSanitizer,
    ) {
        super(
            accountService,
            memberService,
            publicationService,
            reactionTypeService,
            clubsStore,
            publicationHelper,
            postsSignalrService,
            documentService,
            sanitizer,
            mentionPipe,
            linkifyPipe,
        );
    }

    public get isPostRoute(): boolean {
        return this.router.url.includes('/post/');
    }

    public goToPostDetailPage() {
        if (this.publication.commentsCount > 0 && window.innerWidth < 768 && !this.isPostRoute && !this.isFromHomeDrawer) {
            this.navigateToPost();
        }
    }

    private navigateToPost() {
        this.router.navigate(['clubs', 'post', this.publication.id]);
    }

    public onMoreSignal(publication: Publication, goToCommentField: boolean): void{
        this.seeMoreSignal.emit([publication, goToCommentField]);
    }
}
